import { Component, OnInit, AfterViewInit, AfterContentInit, OnChanges, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { TccDetailService } from './services/tcc-detail.service';
import { AuthService } from './services/auth.service';
import { IUser } from './interfaces/iuser';
import { Observable, Subscription } from 'rxjs';


export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnDestroy  {
  
  title = 'tccApp';
  public user:string = "";
  public login : boolean = false;
  subscription: Subscription;
  public imagePath : string = "https://eservices.lra.gov.lr/tccApp/assets/images/tcc_logo.jpg";
 // public imagePath : string = "http://10.0.16.73:8093/tccApp/assets/images/logo3.png";
   // public imagePath : string = "http://localhost:4200/assets/images/Etcc.jpg";
 

  constructor(private router:Router,  private tccService:TccDetailService){
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
  });
  }
 
  ngOnDestroy(): void {
    this.subscription.unsubscribe;
  }
}
 